<template>
  <div class="refund-pager" v-if="lessonList.length > 0">
    <section class="scroll-list-wrap">
      <div class="header">
        <div class="one-lesson" v-for="(item, index) in lessonList" :key="index">
          <div class="cover_image">
            <img :src="item.cover_image" alt="" style="object-fit: cover">
          </div>
          <div class="content">
            <p class="name">{{ item.name }}</p>
            <span class="camp_num">第{{ item.camp_num }}期</span>
            <span class="training_date">开营时间: {{ item.training_date }}</span>
          </div>
        </div>
      </div>
      <div class="desc">
        <p>补充退款说明</p>
        <div class="content">
          <textarea name="reason" id="description" class="description" :readonly="has_apply"
                    placeholder="点击填写退款说明，有助于更好处理售后问题" maxlength="200"
                    v-model="reason"/>
          <span> {{ reason.length }}/200</span>
          <div class="pictures">
            <div class="one-img uploadDiv" @click="uploadImage" v-if="!has_apply">
              <input type="file" id="file" accept=".png,.jpg,.jpeg,.gif"
                     @change="getPicture($event)"
                     style="display: none">
              <img src="../../assets/upload_image.png"/>
            </div>
            <div class="one-img" v-for="(item, index) in images" :key="index">
              <img :src="item" class="upload_image"/>
              <img class="del" src="../../assets/search_icon_close@3x.png" @click="delImage(index)"
                   v-if="!has_apply">
            </div>

          </div>
        </div>

      </div>
      <div class="has_apply" v-if="has_apply">
        <p>退款申请已提交，请耐心等待</p>
      </div>

      <div class="footer" v-if="!has_apply">
        <input type="button" value="申请退款" class="btn_refund" @click="applyRefund"/>
      </div>

    </section>
  </div>

  <div class="refund-empty" v-else>
    <div class="content">
      <p>您没有可退款的营期</p>
      <p>请联系您的班长</p>
      <img src="../../assets/my-clock-in-empty.png"/>
    </div>

  </div>
</template>

<script>

import { queryRefundOrders, refundApply, checkLogin } from '@/api/api';
import { Toast } from 'vant';
import axios from 'axios';

export default {
  name: 'refund',
  computed: {
    options() {
      return {
        scrollbar: true,
        useTransition: false,
        pullUpLoad: true,
        pullDownRefresh: {
          txt: '刷新成功',
        },
      };
    },
  },
  data() {
    return {
      has_apply: false,
      reason: '',
      images: [],
      lessonList: []
    };
  },
  beforeCreate() {
    checkLogin().then((res) => {
      if (!res.data.result) {
        Toast('请先登录');
        window.location.href = res.data.login_url;
      } else {
        console.log('用户已登录');
      }
    });
  },
  created() {
    queryRefundOrders(this.$route.query.purchase_ids).then((res) => {
      this.has_apply = res.has_apply;
      this.reason = res.reason;
      this.images = res.attach;
      this.lessonList = res.items;
      if (this.has_apply) {
        this.reason = res.reason;
      }
      console.log(res, this.has_apply, this.reason, this.images, this.lessonList);
    });
  },

  methods: {
    applyRefund() {
      const purchaseIds = this.$route.query.purchase_ids;
      const attach = { images: this.images };
      const that = this;
      refundApply(purchaseIds, this.reason, attach).then((res) => {
        console.log(res);
        if (res.success === true) {
          Toast('申请成功');
          setTimeout(() => {
            that.has_apply = true;
          }, 800);
        } else {
          Toast('申请失败，请稍后重试!');
        }
      });
    },

    uploadImage() {
      if (this.images.length >= 3) {
        Toast('最多只能选择三张图片');
        return;
      }
      const fileDom = document.querySelector('#file');
      fileDom.click();
    },

    delImage(index) {
      this.images.splice(index, 1);
    },

    getPicture(e) {
      Toast.loading({
        duration: 0, // 持续展示 toast
        message: '加载图片中...',
        forbidClick: true,
      });
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (() => {
        const formData = new FormData();
        formData.append('image', file);
        formData.append('prefix', 'apply/attach');
        axios.post('/api/upload/oss_img_formdata', formData, {}).then((res) => {
          this.images.push(res.data.data.url);
          Toast.clear();
        });
      });
    },

  }
};
</script>

<style scoped lang="stylus">
@import './../../common/stylus/variable.styl';
@import './../../common/stylus/mixin.styl';

.refund-pager {
  position: relative;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  margin: 0 auto;
  width: 100vw;
  height: 100vh;
  max-width: 600px;
  overflow: hidden;
  background-color #F6F6F6
  padding 16px;
}

/* header start */

.refund-pager .header {
  width: 100%;
  background-color #fff;
  margin: 0 auto;
  border-radius 8px;
}

.refund-pager .one-lesson {
  clear: both
  height 107px;
  padding: 16px;
}

.refund-pager .one-lesson .cover_image {
  float left;
  border-radius 10px;
}

.refund-pager .one-lesson .cover_image img {
  width: 60px;
  height 75px;
  border-radius 3.6px;
}

.refund-pager .one-lesson .content {
  width: 80%;
  float left;
  padding-left: 12px;
}

.refund-pager .one-lesson .content .name {
  width: 100%;
  font-size 18px;
  text-overflow ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /*autoprefixer: off*/
  /*autopprefixer: on*/
  -webkit-line-clamp: 1;
  overflow: hidden;
  font-family PingFangSC-Semibold, sans-serif;
  margin 8px 0 24px 0;
  color: #191919;
  font-weight 600
}

.refund-pager .one-lesson .content .camp_num {
  margin-right 8px;
}

.refund-pager .one-lesson .content .camp_num,
.refund-pager .one-lesson .content .training_date {
  font-size 12px;
  color: #999;
  margin-top 29px;
}

/* header end*/

/* desc start */
.refund-pager .desc {
  height 264px;
  margin: 16px auto;
  padding-top: 16px;
  background-color #fff;
  border-radius 8px;
}

.refund-pager .desc .content {
  height 78%;
  background-color #FAFAFA;
  margin 16px 12px 12px 12px;
  border-radius 8px;
}

.refund-pager .desc p {
  font-size 16px;
  font-family PingFangSc-Medium, sans-serif;
  font-weight 600;
  padding-left 12px;
}

.refund-pager .desc textarea {
  width 91%;
  margin 12px 24px 36px 12px;
  height 80px;
  font-size 14px;
  resize none;
  border none;
  margin-bottom: 20px;
  background-color #FAFAFA;
}

.refund-pager .desc span {
  margin-right 15px;
  float right;
  margin-top: -20px;
  color #999;
  font-size 14px;
}

.refund-pager .desc .pictures {
  height 68px;
}

.refund-pager .desc .pictures .one-img:first-child {
  margin-left 12px;
}

.refund-pager .desc .pictures .one-img {
  width: 68px;
  height 68px;
  cursor: pointer;
  float left;
  margin-right 8px;
}

.refund-pager .desc .pictures .one-img .upload_image {
  object-fit cover
}

.refund-pager .desc .pictures .one-img:last-child {
  margin-right 0;
}

.refund-pager .desc .pictures .one-img .del {
  width: 13px;
  height: 12px;
  position: relative;
  top: -78px;
  font-size: 18px;
  right: -61px;
  cursor: pointer;
}

.refund-pager .desc .pictures img {
  width: 68px;
  height: 68px;
}

/* desc end */


.refund-pager .has_apply {
  width: 100%;
  font-size 14px;
  color: #999;
  text-align center;
  margin-top 24px;
}

/* footer start */
.refund-pager .footer {
  width 91%;
  height 40px;
  position absolute
  bottom 38px;
}

.refund-pager .footer .btn_refund {
  width 100%;
  height 40px;
  border: none;
  outline: none;
  border-radius: 6px;
  background: linear-gradient(to right, #FCB13F, #FA8C1D);
  box-shadow: 0px 2px 4px 0px rgba(250, 140, 29, .3);
  line-height: 24px;
  color: #fff;
  font-size: 16px;
  text-align: center;
  font-family PingFangSc-Medium, sans-serif;
  font-weight 600
}

/* footer end */

.refund-empty {
  position: relative;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  margin: auto;
  width: 100vw;
  height: 100vh;
  max-width: 600px;
  overflow: hidden;
  text-align center;
  background-color #fff
}


.refund-empty .content {
  position relative;
  top: 25%;
}

.refund-empty .content p {
  font-size 14px;
  color #999;
  overflow-wrap: break-word;
  font-family: PingFangSC-Regular;
  text-align: center;
  line-height: 20px;
}

.refund-empty .content img {
  margin-top 18px;
  width: 255px;
  height 168px
}
</style>
